import { render, staticRenderFns } from "./PlusSimpleIcon.vue?vue&type=template&id=723a5097&"
import script from "./PlusSimpleIcon.vue?vue&type=script&lang=js&"
export * from "./PlusSimpleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports